import { Clock } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface NewsItem {
  id: string
  title: string
  summary?: string
  image_url?: string
  published_at: string
  category?: string
}

interface LatestNewsProps {
  news: NewsItem[]
}

export function LatestNews({ news }: LatestNewsProps) {
  const mockNews: NewsItem[] = [
    {
      id: '1',
      title: 'LeBron James breaks scoring record',
      summary: 'Historic night as the King makes history',
      image_url: '/lovable-uploads/add84af1-ab69-407b-acbe-87d95c4c3026.png',
      published_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
      category: 'NBA'
    },
    {
      id: '2', 
      title: 'Major trade shakes up Western Conference',
      summary: 'Championship implications for playoff race',
      image_url: '/lovable-uploads/add84af1-ab69-407b-acbe-87d95c4c3026.png',
      published_at: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
      category: 'NBA'
    },
    {
      id: '3',
      title: 'Fantasy draft strategies for playoffs',
      summary: 'Expert analysis and player recommendations',
      image_url: '/lovable-uploads/add84af1-ab69-407b-acbe-87d95c4c3026.png',
      published_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
      category: 'Fantasy'
    },
    {
      id: '4',
      title: 'Injury report affects key players',
      summary: 'Latest updates on player availability',
      image_url: '/lovable-uploads/add84af1-ab69-407b-acbe-87d95c4c3026.png',
      published_at: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
      category: 'Injuries'
    }
  ]

  const displayNews = news.length > 0 ? news : mockNews

  const getTimeAgo = (dateString: string) => {
    const now = new Date()
    const date = new Date(dateString)
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60)
    
    if (diffInHours < 1) {
      return `${Math.floor(diffInHours * 60)} minutes ago`
    } else if (diffInHours < 24) {
      return `${Math.floor(diffInHours)} hours ago`
    } else {
      return `${Math.floor(diffInHours / 24)} days ago`
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-primary" />
          Latest News
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {displayNews.slice(0, 4).map((item) => (
            <div 
              key={item.id} 
              className="flex gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer"
            >
              {item.image_url && (
                <div className="w-12 h-12 rounded-lg overflow-hidden shrink-0">
                  <img 
                    src={item.image_url} 
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
              
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm line-clamp-2 mb-1">
                  {item.title}
                </h4>
                {item.summary && (
                  <p className="text-xs text-muted-foreground line-clamp-1 mb-2">
                    {item.summary}
                  </p>
                )}
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  {item.category && (
                    <span className="bg-primary/10 text-primary px-2 py-1 rounded">
                      {item.category}
                    </span>
                  )}
                  <span>{getTimeAgo(item.published_at)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}